var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAffiliate = function SvgAffiliate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.083,
    d: "M10 2.042a3.435 3.435 0 1 0 0 6.869 3.435 3.435 0 0 0 0-6.87Zm0 5.654a2.22 2.22 0 1 1 0-4.44 2.22 2.22 0 0 1 0 4.44ZM3.173 11.131v3.155h1.214v-3.113h11.226v3.156h1.214v-3.2399999999999998a1.173 1.173 0 0 0-1.172-1.13H4.345c-.633 0-1.15.502-1.172 1.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.345 13.393a2.262 2.262 0 1 0 0 4.524 2.262 2.262 0 0 0 0-4.524m0 3.393a1.13 1.13 0 1 1 0-2.262 1.13 1.13 0 0 1 0 2.262M10 13.393a2.262 2.262 0 1 0 0 4.524 2.262 2.262 0 0 0 0-4.524m0 3.393a1.13 1.13 0 1 1 0-2.262 1.13 1.13 0 0 1 0 2.262m5.655-3.393a2.262 2.262 0 1 0 0 4.525 2.262 2.262 0 0 0 0-4.525m0 3.393a1.13 1.13 0 1 1 0-2.261 1.13 1.13 0 0 1 0 2.26"
  })));
};
export default SvgAffiliate;